import type { OperatorInfoInput } from '@@partner:graphql/mutation/employees/saveOperator.gql'
import type { Operator } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

export interface OperatorFormState {
  id?: GQL_ID
  firstName: string
  lastName: string
  phone: string
  status: number
  email: string

  changePassword: boolean
  password: string
  repeatPassword: string
}

export const PROMOCODE_DEFAULT_STATE: OperatorFormState = {
  id: undefined,
  firstName: '',
  lastName: '',
  phone: '',
  status: 0,
  email: '',
  changePassword: false,
  password: '',
  repeatPassword: ''
}

export const makeOperatorFormState = (
  operator?: Operator
): OperatorFormState => {
  return mapApiDataToState(operator ?? ({} as Operator))
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (
  state: OperatorFormState
): OperatorInfoInput => ({
  id: state.id,
  first_name: state.firstName,
  last_name: state.lastName,
  phone: state.phone,
  email: state.email,
  status: Number(state.status) ?? 0,
  password: state.changePassword || !state.id ? state.password : undefined
})

export const mapApiDataToState = (data: Operator): OperatorFormState => ({
  id: data.id,
  firstName: data.first_name,
  lastName: data.last_name,
  phone: data.phone,
  status: data.status,
  email: data.email,
  password: '',
  repeatPassword: '',
  changePassword: false
})
